import { render, staticRenderFns } from "./edit_copy.vue?vue&type=template&id=18767eb5&scoped=true&"
import script from "./edit_copy.vue?vue&type=script&lang=js&"
export * from "./edit_copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18767eb5",
  null
  
)

export default component.exports